<template>
  <div class="page_ page_fixed_form_control_wrapper_">
    <a-form
      :form="form"
      @submit="handleFormSubmit"
      class="form_ horizontal_item_"
    >
      <a-row :gutter="50">
        <a-col :span="10">
          <a-form-item :label="$t('addPolicy.a2')">
            <a-input
              v-decorator="['holderName']"
              :placeholder="$t('input.a')"
            ></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="10">
          <a-form-item :label="$t('addPolicy.c2')">
            <a-input
              v-decorator="['holderIdNumber']"
              :placeholder="$t('input.a')"
            ></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="10">
          <a-form-item :label="$t('addPolicy.f2')">
            <a-input
              v-decorator="['holderPhone']"
              :placeholder="$t('input.a')"
            ></a-input>
          </a-form-item>
        </a-col>
        <!--<a-col :span="10">
          <a-form-item :label="$t('addPolicy.a5')">
            <a-input
              v-decorator="['insuredName']"
              :placeholder="$t('input.a')"
            ></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="10">
          <a-form-item :label="$t('order[3]') || '保单号'">
            <a-input
              v-decorator="['policyNo']"
              :placeholder="$t('input.a')"
            ></a-input>
          </a-form-item>
        </a-col>-->
        <a-col :span="4">
          <a-form-item>
            <a-button html-type="submit" type="primary">{{
              $t("order[4]") || "查询"
            }}</a-button>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <h5>{{ $t("order[5]") || "保单信息" }}</h5>
    <a-form
      :class="{ ens_fix_: currentLang != 1 }"
      class="horizontal_item_ fix_mrg_"
    >
      <a-form-item :label="$t('order[3]') || '保单号'">
        {{ info.policyNo || "-" }}
      </a-form-item>
      <a-form-item :label="$t('order[6]') || '产品名称'">
        {{ info.productName || "-" }}
      </a-form-item>
      <a-form-item :label="$t('order[7]') || '承保公司'">
        {{ info.corportionName || "-" }}
      </a-form-item>
      <a-form-item :label="$t('addPolicy.a2')">
        {{ info.holderName || "-" }}
      </a-form-item>
      <a-form-item :label="$t('order[8]') || '生效日期'">
        {{ info.startDate || "-" }}
      </a-form-item>
      <a-form-item :label="$t('order[9]') || '终止日期'">
        {{ info.endDate || "-" }}
      </a-form-item>
      <a-form-item class="clearfix_">
        <a-button class="f_r_" type="primary"
          ><a target="_blank" :href="info.downloadUrl">{{
            $t("order[10]") || "下载电子保单"
          }}</a></a-button
        >
      </a-form-item>
    </a-form>
  </div>
</template>
<style lang="scss" scoped>
/* 移动端  */
@media all and (max-width: 750px) {
  .form_ {
    padding: 8vw 6.9333vw;
    background: #fff;
    margin-top: 5.8667vw;
  }
  .horizontal_item_ {
    padding: 7.2vw 8.8vw;
    background: #fff;
  }
  .fix_mrg_ {
    margin-bottom: 12.2667vw;
  }
  h5 {
    font-size: 3.7333vw;
    line-height: 4.5333vw;
    border-left: 0.8vw solid #ff3e18;
    margin-left: 6.9333vw;
    margin: 3.2vw 0;
    padding-left: 4.8vw;
  }
}
/* PC端 */
@media all and (min-width: 750px) {
  .form_ {
    padding: 30px 26px;
    background: #fff;
    margin-top: 22px;
  }
  .horizontal_item_ {
    padding: 27px 33px;
    background: #fff;
  }
  .fix_mrg_ {
    margin-bottom: 46px;
  }
  h5 {
    font-size: 14px;
    line-height: 17px;
    border-left: 3px solid #ff3e18;
    margin-left: 26px;
    margin: 12px 0;
    padding-left: 18px;
  }
}
</style>
<script>
import policyQueryMixin from "./mixins/policyQuery";
import policyMixin from "./mixins/policy";

export default {
  data() {
    return {
      form: this.$form.createForm(this),
      info: {},
    };
  },
  mixins: [policyQueryMixin, policyMixin],
  mounted() {
    const { holderPhone, holderIdNumber } = this.$route.params;
    if (holderPhone) {
      this.queryPolicyOrder({
        holderPhone,
        holderIdNumber,
      });
    }
  },
  methods: {},
};
</script>